<template>
    <div id="conteneurDoss" v-if="this.$store.state.user.role.label == 'eleve'">
      <HeaderHome :user="this.$store.state.user.prenom" />

      <template v-if="checkLoad">
        <main class="page-main">
          <div class="page-header">
            <div class="page-header-left">
              <h1 class="page-title">Mes informations</h1>
              <p class="page-subtitle">Données personnelles de votre dossier</p>
            </div>
          </div>

          <div class="page-card">
            <Formulaire :userData="form" :showValidation="showValidation" :isWorking="isWorking" @update="update($event)"
              @updateCheckAll="updateCheckAll($event)" @ordreVueMobile="ordreVueMobile($event)"
              @saveDossier="saveDossier($event)"></Formulaire>
          </div>
        </main>
      </template>

      <template v-else>
        <Loader />
      </template>
    </div>
  </template>
  
  <script>
  import Loader from "@/components/Loader.vue";
  import Formulaire from "@/components/dossier/Formulaire.vue";
  import HeaderHome from "@/components/home/HeaderHome.vue";
  // Formulaire est la partie de droite dans la page

  export default {
    name: "Dossier",
    beforeCreate() {
      // Si il n'y a pas le paramètre, on ne sait pas d'où l'utilisateur provient dans le site donc si il peut ou non payé.
      if (this.$route.params.personalData === undefined) {
        // Alors redirection
        this.$router.push({ name: "Home" });
      }
    },
    components: {
      Loader,
      Formulaire,
      HeaderHome,
    },
    data() {
      return {
        form: {
          nom: this.$store.state.user.nom,
          prenom: this.$store.state.user.prenom,
          telephone: this.$store.state.user.telephone,
          mailEleve: this.$store.state.user.email,
          dossier: {},
        },
        isWorking: false,
        showValidation: true,
        checkAll: false,
        contractData: "",
        fileList: [],
        putFile: false,
        contract: [],
        questions: "",
      };
    },
    mounted() {
      this.loadDossier();
      this.getContract();
    },
    methods: {
  
      validFormContract() {
        let inputs = document.querySelectorAll("#questionCont");
  
        let responseContract = [];
        let countTot = 0;
        inputs.forEach(input => {
          if (input.checked) {
            responseContract.push(parseInt(input.attributes[2].value))
            countTot = countTot + parseInt(input.attributes[2].value);
          } else {
            responseContract.push(0)
          }
        });
        responseContract.push(countTot);
        if (countTot <= 3) {
          responseContract.push([20, 40]);
        } else if (countTot > 3 && countTot <= 7) {
          responseContract.push([15, 35]);
        } else if (countTot > 7 && countTot <= 10) {
          responseContract.push([10, 20]);
        }
  
        window.api.post("/contracts", {
          eleve: "api/utilisateurs/" + this.$store.state.user.id,
          question: responseContract,
        },
          {
            headers: {
              "Authorization": "Bearer " + this.$store.state.token
            },
          }).then(() => {
            this.getContract();
          }).catch(error => {
            console.log(error)
          })
      },
  
      async loadDossier() {
        try {
          // Charge les infos nécessaires à la fonctionnalité
          window.api
            .get("/dossier/info", {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              // Place dans le store les informations récupérées
              this.$store.state.fonctionnalite = response.data.fonctionnalite;
              this.$store.state.permis = response.data.permis;
              this.$store.state.statutSocial = response.data.statutSocial;
              this.$store.state.lycees = response.data.lycee;
            });
          // Charge les types de pièces justificatives pour pouvoir recalculer les pièces de l'utilisateur
          window.api
            .get("/type_piece_justificative", {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              // Place dans le store les types de pièce justificatives
              this.$store.state.typePieceJustificative =
                response.data["hydra:member"];
            });
          // Si le dossier n'est pas chargé ou qu'il provient de la base de donnée
          if (
            this.$store.state.dossier === null ||
            this.$store.state.dossier.id !== undefined
          ) {
            if (this.$store.state.user.dossier !== null) {
              // Si l'utilisateur à un dossier en base de donnée
              window.api
                .get("/dossiers/" + this.$store.state.user.dossier.id, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                })
                .then((response) => {
                  // Place le dossier dans les data de la page
                  this.form.dossier = response.data;
                  // Place dans le store le dossier
                  this.$store.commit("setDossier", response.data);
                });
            } else {
              // Sinon, on créé un objet vide
              let emptyDossier = {
                nomUsage: "",
                autresPrenom: "",
                telParent: "",
                mailParent: "",
                adresse: "",
                codePostal: "",
                ville: "",
                dateNaissance: "",
                paysNaissance: "",
                depNaissance: "",
                villeNaissance: "",
                nationaliteFR: "null",
                parlerFRCouramment: "null",
                vehiculeAmenage: "null",
                lunettes: "null",
                permis: "null",
                faitSuite: "null",
                motifAlcoolStup: "null",
                prevoitAac: "null",
                social: "null",
                metier: "",
                lycee: "null",
                autreLycee: "",
                numNeph: "",
              };
              // Place le dossier vide dans les data de la page
              this.form.dossier = emptyDossier;
              // Place dans le store le dossier
              this.$store.commit("setDossier", emptyDossier);
            }
          } else {
            // Place le dossier du store dans les data de la page
            this.form.dossier = this.$store.state.dossier;
          }
        } catch (e) {
          // Si un des chargements a echoués, retour au menu home
          this.$router.push({ name: "Home" });
        }
      },
      saveDossier(mode) {
        // Lance la sauvegarde du dossier
        this.showValidation = true;
        // Si tout les champs sont valide
        if (this.checkAll) {
          this.isWorking = true;
          // Démarre les boutons de sauvegarde
          this.$store.dispatch("startSaveBouton", mode);
  
          if (this.form.dossier.motifAlcoolStup === null) {
            this.form.dossier.motifAlcoolStup = false;
          }
          let tmpFormDossier = this.form.dossier;
          // Comparaison "true" ou true = true pour être sur d'envoyer correctement le true
          // Sinon, la comparaison = false
          tmpFormDossier.nationaliteFR =
            tmpFormDossier.nationaliteFR === "true" ||
            tmpFormDossier.nationaliteFR === true;
          tmpFormDossier.parlerFRCouramment =
            tmpFormDossier.parlerFRCouramment === "true" ||
            tmpFormDossier.parlerFRCouramment === true;
          tmpFormDossier.lunettes =
            tmpFormDossier.lunettes === "true" ||
            tmpFormDossier.lunettes === true;
          tmpFormDossier.vehiculeAmenage =
            tmpFormDossier.vehiculeAmenage === "true" ||
            tmpFormDossier.vehiculeAmenage === true;
          tmpFormDossier.prevoitAac =
            tmpFormDossier.prevoitAac === "true" ||
            tmpFormDossier.prevoitAac === true;
          tmpFormDossier.faitSuite =
            tmpFormDossier.faitSuite === "true" ||
            tmpFormDossier.faitSuite === true;
          tmpFormDossier.motifAlcoolStup =
            tmpFormDossier.motifAlcoolStup === "true" ||
            tmpFormDossier.motifAlcoolStup === true;
          if (tmpFormDossier.lycee === "null") {
            tmpFormDossier.lycee = null;
          }
          if (this.$store.state.dossier.id === undefined) {
            // Si pas de dossier en base de donnée alors post
            window.api
              .post(
                "/dossiers",
                {
                  eleve: "/api/utilisateurs/" + this.$store.state.user.id,
                  ...tmpFormDossier,
                  ants: false,
                  espaceQuestions: "",
                  typeFabrication: null,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then((response) => {
                // Place le dossier dans le store
                this.$store.state.dossier = response.data;
                // Initialisation de typePieces avec les pièces permanente
                let typePieces = this.$store.state.typePieceJustificative.filter(
                  (el) => el.useCase === "dossier"
                );
                // Calcul de l'age
                let age =
                  new Date().getUTCFullYear() -
                  new Date(
                    this.$store.state.dossier.dateNaissance
                  ).getUTCFullYear();
  
                // Suivant des conditions, différents type de pièce sont ajoutés à typePieces
  
                // Si l'élève a entre 17 ans inclus et 25 ans exclu
                if (age >= 17 && age < 25) {
                  Array.prototype.push.apply(
                    typePieces,
                    this.$store.state.typePieceJustificative.filter(
                      (el) => el.useCase === "age"
                    )
                  );
                }
                // Si la demande fait suite à une annulation/invalidation de permis
                if (this.$store.state.dossier.faitSuite) {
                  Array.prototype.push.apply(
                    typePieces,
                    this.$store.state.typePieceJustificative.filter(
                      (el) => el.useCase === "faitSuite"
                    )
                  );
                  // Si l'annulation/invalidation est lié à l'alcool ou la drogue
                  if (this.$store.state.dossier.motifAlcoolStup) {
                    Array.prototype.push.apply(
                      typePieces,
                      this.$store.state.typePieceJustificative.filter(
                        (el) => el.useCase === "faitSuite/oui"
                      )
                    );
                  } else {
                    Array.prototype.push.apply(
                      typePieces,
                      this.$store.state.typePieceJustificative.filter(
                        (el) => el.useCase === "faitSuite/non"
                      )
                    );
                  }
                }
                // Mise à jour des pièces relatives à l'utilisateur
                window.api
                  .post(
                    "/dossier/piece",
                    {
                      dossier: this.$store.state.dossier,
                      typePieces: typePieces,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    }
                  )
                  .then((response) => {
                    // Place dans le store le dossier après mise à jour des pièces
                    this.$store.state.dossier = response.data;
                  })
                  .catch((error) => {
                    // En cas d'échec de mise à jour des pièces, retour au menu home
                    this.$router.push({ name: "Home" });
                    console.log(error);
                  });
                
                // Lance la mise à jour de l'utilisateur
                this.saveUser(mode);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            // Si dossier en base de donnée alors patch
            window.api
              .patch(
                "/dossiers/" + this.$store.state.dossier.id,
                {
                  ...tmpFormDossier,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    "Content-Type": "application/merge-patch+json",
                  },
                }
              )
              .then((response) => {
                // Place le dossier dans le store
                this.$store.state.dossier = response.data;
                // Initialisation de typePieces avec les pièces permanente
                let typePieces = this.$store.state.typePieceJustificative.filter(
                  (el) => el.useCase === "dossier"
                );
                // Calcul de l'age
                let age =
                  new Date().getUTCFullYear() -
                  new Date(
                    this.$store.state.dossier.dateNaissance
                  ).getUTCFullYear();
  
                // Suivant des conditions, différents type de pièce sont ajoutés à typePieces
  
                // Si l'élève a entre 17 ans inclus et 25 ans exclu
                if (age >= 17 && age < 25) {
                  Array.prototype.push.apply(
                    typePieces,
                    this.$store.state.typePieceJustificative.filter(
                      (el) => el.useCase === "age"
                    )
                  );
                }
                // Si la demande fait suite à une annulation/invalidation de permis
                if (this.$store.state.dossier.faitSuite) {
                  Array.prototype.push.apply(
                    typePieces,
                    this.$store.state.typePieceJustificative.filter(
                      (el) => el.useCase === "faitSuite"
                    )
                  );
                  // Si l'annulation/invalidation est lié à l'alcool ou la drogue
                  if (this.$store.state.dossier.motifAlcoolStup) {
                    Array.prototype.push.apply(
                      typePieces,
                      this.$store.state.typePieceJustificative.filter(
                        (el) => el.useCase === "faitSuite/oui"
                      )
                    );
                  } else {
                    Array.prototype.push.apply(
                      typePieces,
                      this.$store.state.typePieceJustificative.filter(
                        (el) => el.useCase === "faitSuite/non"
                      )
                    );
                  }
                }
                // Mise à jour des pièces relatives à l'utilisateur
                window.api
                  .post(
                    "/dossier/piece",
                    {
                      dossier: this.$store.state.dossier,
                      typePieces: typePieces,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    }
                  )
                  .then((response) => {
                    // Place dans le store le dossier après mise à jour des pièces
                    this.$store.state.dossier = response.data;
                  })
                  .catch((error) => {
                    // En cas d'échec de mise à jour des pièces, retour au menu home
                    this.$router.push({ name: "Home" });
                    console.log(error);
                  });
  
                // Lance la mise à jour de l'utilisateur
                this.saveUser(mode);
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      },
      saveUser(mode) {
        // Update des données utilisateurs
        window.api
          .patch(
            "/utilisateur/" + this.$store.state.user.id,
            {
              nom: this.form.nom,
              prenom: this.form.prenom,
              telephone: this.form.telephone,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            // Place dans le store 
            this.$store.commit("setUser", response.data.utilisateur[0]);
            let fonctionnalite = "dossier";
            let router = this.$router;
            // Stop les boutons de sauvegarde
            this.$store.dispatch("endSaveBouton", {
              mode,
              fonctionnalite,
              router,
            });
            this.isWorking = false;
          })
          .catch((error) => {
            console.log(error);
          });
      },
  
      ordreVueMobile(e) {
        if (e.target.id == "btnSuivantVueMobile") {
          // Permet le passage à la première étape du dossier sur la vue mobile
          document.getElementById("descriptif").style.display = "none";
          document.getElementById("conteneurDoss").style.background = "none";
          document.getElementById("dossierFormulaire").style.display = "initial";
        } else if (e.target.id == "btnRetourVueMobile") {
          // Permet le retour avant la première étape du dossier sur la vue mobile
          document.getElementById("conteneurDoss").style.background =
            "linear-gradient(323deg, #fbbb5b 35%, #de6fa8 100%, #07989f 0%)";
          document.getElementById("descriptif").style.display = "initial";
          document.getElementById("dossierFormulaire").style.display = "none";
        }
      },
  
      update(userData) {
        // update des infos du dossier depuis le composant Formulaire
        this.form = userData;
      },
  
      updateCheckAll(value) {
        // update du checkAll depuis le composant Formulaire
        this.checkAll = value;
      },
  
      getContract() {
        window.api.get("/contract/" + this.$store.state.user.id, {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          this.contract = response.data;
          this.contractData = "data:application/pdf;base64," + response.data.pdf;
          this.questions = response.data.questions;
        }).catch(error => {
          console.log(error)
        })
      },
  
      addFile() {
        this.fileList = [];
        let input = document.getElementById("file_input_cont");
        const reader = new FileReader();
        reader.onloadend = () => {
          this.fileList.push({
            file_name: input.files[0].name,
            file_data: reader.result,
          });
        };
        reader.readAsDataURL(input.files[0]);
  
        this.putFile = true;
      },
  
      savePiece() {
        if (this.contract.contractEleve.length == 0) {
          window.api.post("/contracts", {
            piece: this.fileList,
            status: "En Attente",
            eleve: "api/utilisateurs/" + this.$store.state.user.id,
          },
            {
              headers: {
                "Authorization": "Bearer " + this.$store.state.token
              },
            }).then(() => {
              this.getContract();
            }).catch(error => {
              console.log(error)
            })
        } else {
          window.api.put("/contracts/" + this.contract.contractEleve[0].id, {
            piece: this.fileList,
            status: "En Attente",
            eleve: "api/utilisateurs/" + this.$store.state.user.id,
          },
            {
              headers: {
                "Authorization": "Bearer " + this.$store.state.token
              },
            }).then(() => {
              this.getContract();
            }).catch(error => {
              console.log(error)
            })
        }
      }
  
    },
    computed: {
      checkLoad() {
        return (
          this.$store.state.fonctionnalite !== null &&
          this.$store.state.permis !== null &&
          this.$store.state.statutSocial !== null &&
          this.$store.state.lycees !== null &&
          this.form.dossier.codePostal !== undefined
        );
      },
    },
  };
  </script>
  
  <style scoped>
  #conteneurDoss {
    background: #f4f6f9;
    min-height: 100vh;
  }

  .page-main {
    width: 90%;
    margin: 0 auto;
    padding: 40px 40px;
    text-align: left;
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
  }

  .page-header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .page-title {
    font-size: 30px;
    font-weight: bold;
    color: #1a1f2e;
    letter-spacing: -0.5px;
    margin: 0;
  }

  .page-subtitle {
    font-size: 14px;
    color: #64748b;
    margin: 0;
  }

  .page-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
  }

  @media (max-width: 1100px) {
    .page-main {
      width: 100%;
      padding: 24px 20px;
      box-sizing: border-box;
    }
  }
  </style>